import { composeClasses } from '@/utils/compose-classes'

export interface SkeletonProps {
  width: string
  height: string
  rounded?: string
  color?: string
  className?: string
}

export const Skeleton = ({
  width,
  height,
  rounded = 'rounded-xl',
  color = 'bg-surface-strokes',
  className
}: SkeletonProps) => {
  return (
    <div
      data-testid="skeleton"
      className={composeClasses(
        className,
        color,
        rounded,
        width,
        height,
        'animate-pulse'
      )}
    />
  )
}

export default Skeleton
